<div class="poll-dashboard">
    @if (results(); as results) {
        @if (results.totalSelections === 0) {
            <div class="no-results">
                <h3>No Poll Results Yet</h3>
                <p>
                    Poll results will appear here as listeners cast their votes.
                </p>
            </div>
        } @else {
            <div class="poll-stats">
                <div class="poll-stat">
                    <p>Total Poll Votes</p>
                    <h2>{{ results.totalSelections | number }}</h2>
                </div>
                <div class="poll-stat">
                    <p>Total Selections</p>
                    <h2>{{ results.results.length | number }}</h2>
                </div>
                <div class="poll-stat">
                    <p>Avg. Selections Per Respondent</p>
                    <h2>
                        {{ results.averageSelectionsPerRespondent | number }}
                    </h2>
                </div>
                <div class="poll-stat">
                    <p>Median Votes</p>
                    <h2>{{ results.medianVotes | number }}</h2>
                </div>
            </div>
            @if (poll(); as poll) {
                <div class="poll-controls">
                    @if (poll.isMultiSelect) {
                        <tools-input
                            prefix="search"
                            placeholder="Search"
                            [formControl]="searchControl"
                        />
                        <tools-toggle
                            [isChecked]="writeInOnly()"
                            [labelPosition]="LabelPosition.BEFORE"
                            (change)="writeInOnly.set($event.checked)"
                        >
                            Show Write-In Submissions Only
                        </tools-toggle>
                    }
                    <tools-button
                        (onClick)="downloadCSV()"
                        class="download-csv-btn"
                    >
                        Export as CSV
                    </tools-button>
                </div>
                <div class="poll-results-table">
                    <app-poll-results-table
                        [results]="results.results"
                        [displayIsWriteInColumn]="poll.isMultiSelect"
                        [displayPercentageColumn]="!poll.isMultiSelect"
                        [showFooter]="poll.isMultiSelect"
                        [searchQuery]="searchQuery()"
                        [writeInOnly]="writeInOnly()"
                    />
                </div>
            }
        }
    } @else {
        <div class="loading"></div>
    }
</div>
